module.exports = __webpack_public_path__ + "img/domestic-2009-economic-opinion.14595144.jpg";